import { Button, InputLabel, Stack, Typography, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useRef, useState } from "react";
import { APP_LOGO } from "../../assets";
import AuthContainer from "../../components/containers/AuthContainer";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppLoader from "../../components/loader/loader";
import TextInput from "../../components/textInput";

const CustomerSupport = () => {
    const constants = useRef(null);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [issueType, setIssueType] = useState("");
    const [message, setMessage] = useState("");

    const issueTypes = [
        "Technical Issue",
        "Account Problem",
        "Payment Issue",
        "Job Booking Problem",
        "App Bug Report",
        "Feature Request",
        "Other"
    ];

    const handleOpenSnackBar = (type, message) => {
        if (constants.current) {
            constants.current.isOpenSnack({
                snackType: type,
                snackMessage: message,
            });
        }
    };

    const handleSend = () => {
        if (!name.trim()) {
            handleOpenSnackBar("error", "Name is required");
            return;
        }
        if (!email.trim()) {
            handleOpenSnackBar("error", "Email is required");
            return;
        }
        if (!issueType.trim()) {
            handleOpenSnackBar("error", "Please select an issue type");
            return;
        }
        if (!message.trim()) {
            handleOpenSnackBar("error", "Please describe your issue");
            return;
        }

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            handleOpenSnackBar("success", "Your support request has been submitted successfully. Our team will contact you soon.");
            setName("");
            setEmail("");
            setIssueType("");
            setMessage("");
        }, 2000);
    };

    return (
        <AuthContainer>
            <Stack alignItems="center">
                <img src={APP_LOGO.appLogo} width={177} alt="App Logo" />
            </Stack>

            <Typography my={2} fontSize="1.5rem" fontWeight={600} textAlign="center">
                Customer Support
            </Typography>
            <Typography textAlign="center" color="text.secondary" mb={2}>
                Having trouble? We're here to help! Please describe your issue and our support team will get back to you as soon as possible.
            </Typography>

            <Grid container mt={2}>
                <Grid item xs={12} md={12} width={"100%"}>
                    <InputLabel className="input-label">Full Name</InputLabel>
                    <TextInput
                        placeholder="Enter your full name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={12} width={"100%"}>
                    <InputLabel className="input-label">Email Address</InputLabel>
                    <TextInput
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={12} width={"100%"}>
                    <InputLabel className="input-label">Issue Type</InputLabel>
                    <TextInput
                        select
                        placeholder="Select issue type"
                        value={issueType}
                        onChange={(e) => setIssueType(e.target.value)}
                    >
                        {issueTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                                {type}
                            </MenuItem>
                        ))}
                    </TextInput>
                </Grid>
                <Grid item xs={12} md={12} width={"100%"}>
                    <InputLabel className="input-label">Describe Your Issue</InputLabel>
                    <TextInput
                        placeholder="Please provide detailed information about your issue..."
                        multiline
                        rows={4}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </Grid>
            </Grid>

            <Button
                variant="contained"
                onClick={handleSend}
                disabled={loading}
                sx={{ mt: 3, height: 45 }}
                fullWidth
            >
                {loading ? "Submitting Request..." : "Submit Support Request"}
            </Button>

            <AppLoader isVisible={loading} />
            <CustomSnackbar ref={constants} />
        </AuthContainer>
    );
};

export default CustomerSupport;
